import { useState } from 'react'
import PropTypes from 'prop-types'
import {
    AlignHorizontalJustifyStart,
    AlignHorizontalJustifyCenter,
    AlignHorizontalJustifyEnd,
    AlignVerticalJustifyStart,
    AlignVerticalJustifyCenter,
    AlignVerticalJustifyEnd,
    AlignHorizontalDistributeCenter,
    AlignVerticalDistributeCenter,
} from 'lucide-react'
import { useTools } from "../../ToolProvider.jsx";
import SideMenu from './SideMenu.jsx';

const ALIGN_BUTTONS = [
    { edge: 'left', label: 'Alinear a la izquierda', Icon: AlignHorizontalJustifyStart },
    { edge: 'centerH', label: 'Centrar horizontalmente', Icon: AlignHorizontalJustifyCenter },
    { edge: 'right', label: 'Alinear a la derecha', Icon: AlignHorizontalJustifyEnd },
    { edge: 'top', label: 'Alinear arriba', Icon: AlignVerticalJustifyStart },
    { edge: 'centerV', label: 'Centrar verticalmente', Icon: AlignVerticalJustifyCenter },
    { edge: 'bottom', label: 'Alinear abajo', Icon: AlignVerticalJustifyEnd },
];

const REFERENCE_OPTIONS = [
    { value: 'selection', label: 'Selección' },
    { value: 'first', label: 'Primero seleccionado' },
    { value: 'biggest', label: 'El más grande' },
    { value: 'background', label: 'Fondo' },
];

const DropdownAlignDistribute = ({ selectedCount = 0 }) => {
    const { onAlignObjects, onDistributeObjects } = useTools();
    const [referenceMode, setReferenceMode] = useState('selection');

    if (selectedCount < 1) return null;

    const canDistribute = selectedCount >= 3;

    return (
        <SideMenu
            tip="Alinear y distribuir"
            icon={<AlignHorizontalJustifyCenter className="w-10 h-10" />}
            menuClassName="menu p-2 w-56 gap-2"
        >
                <select
                    className="select select-sm select-bordered w-full"
                    value={referenceMode}
                    onChange={(event) => setReferenceMode(event.target.value)}
                >
                    {REFERENCE_OPTIONS.map(({ value, label }) => (
                        <option key={value} value={value}>Respecto a: {label}</option>
                    ))}
                </select>

                <div className="grid grid-cols-3 gap-1">
                    {ALIGN_BUTTONS.map(({ edge, label, Icon }) => (
                        <button
                            key={edge}
                            type="button"
                            className="btnMod tooltip tooltip-bottom"
                            data-tip={label}
                            onClick={() => onAlignObjects(edge, referenceMode)}
                        >
                            <Icon className="w-6 h-6" />
                        </button>
                    ))}
                </div>

                <div className="divider my-1" />

                <div className="grid grid-cols-2 gap-1">
                    <button
                        type="button"
                        className="btnMod tooltip tooltip-bottom"
                        data-tip="Distribuir horizontalmente"
                        disabled={!canDistribute}
                        onClick={() => onDistributeObjects('horizontal')}
                    >
                        <AlignHorizontalDistributeCenter className="w-6 h-6" />
                    </button>
                    <button
                        type="button"
                        className="btnMod tooltip tooltip-bottom"
                        data-tip="Distribuir verticalmente"
                        disabled={!canDistribute}
                        onClick={() => onDistributeObjects('vertical')}
                    >
                        <AlignVerticalDistributeCenter className="w-6 h-6" />
                    </button>
                </div>
        </SideMenu>
    );
};

DropdownAlignDistribute.propTypes = {
    selectedCount: PropTypes.number,
};

export default DropdownAlignDistribute;
